import { render, staticRenderFns } from "./Code.vue?vue&type=template&id=ca4cdd40&scoped=true"
import script from "./Code.vue?vue&type=script&lang=js"
export * from "./Code.vue?vue&type=script&lang=js"
import style0 from "./Code.vue?vue&type=style&index=0&id=ca4cdd40&prod&lang=css"
import style1 from "./Code.vue?vue&type=style&index=1&id=ca4cdd40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4cdd40",
  null
  
)

export default component.exports